import { useState } from 'react';
import { copyText } from '@/lib/format';
import { cn } from '@/lib/utils';
import { Icon } from '@/components/Icon';
import { Button } from '@/components/ui/button';

/** Copies `text`; shows a check for 1.5 s afterwards. `onCopied` runs only when the clipboard write succeeded. */
export function CopyButton({ text, label = 'Copy', className, testId, size = 'sm', onCopied }: { text: string; label?: string; className?: string; testId?: string; size?: 'sm' | 'icon-sm'; onCopied?: () => void }) {
  const [done, setDone] = useState(false);
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      data-testid={testId}
      aria-label={size === 'icon-sm' ? label : undefined}
      className={cn('shrink-0', className)}
      onClick={() => {
        void copyText(text).then((ok) => {
          if (!ok) return;
          onCopied?.();
          setDone(true);
          setTimeout(() => setDone(false), 1500);
        });
      }}
    >
      <Icon name={done ? 'check_circle' : 'content_copy'} size={16} className={done ? 'text-succeeded' : undefined} />
      {size === 'sm' ? (done ? 'Copied' : label) : null}
    </Button>
  );
}
